export class ConnectivityStatus {
	constructor(connectivity) {
		this.connectionStatusInfo = {
			status: connectivity.connectionStatusInfo.status
		};
		this.currentDataUplink = {
			status: connectivity?.currentDataUplink?.status,
			startAt: connectivity?.currentDataUplink?.startAt,
			endAt: connectivity?.currentDataUplink?.endAt
		};
	}

	get status() {
		return this.connectionStatusInfo?.status;
	}

	get dataUplinkStatus() {
		return this.currentDataUplink?.status;
	}
}
